module.exports = __webpack_public_path__ + "static/media/daily-ui2.dca93064.png";